import {
  $ProcedureTraining,
  FetchAllCategoriesForTrainingPrograms,
} from "@store/company/procedure-training-store";
import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import React, { useEffect, useState } from "react";

import { NavLink } from "react-router-dom";
import { BodyNormal } from "@ui/fonts";
import { CategoryTable } from "./category-table";
import { ExternalLinkSVG } from "@components/svgs/external-link";
import { GroupSwitch } from "@components/group-switch";
import styles from "./study-center.module.scss";
import { useUnit } from "effector-react";
import { useStudyCenterProgramsQuery } from "@lib/study-center";
import { SELECTS_ID } from "@store/company/procedure-instrunctions-store";

export const StudyCenter: React.FC = () => {
  const permissions = useUnit($UserAddPermissions);
  const { categories } = useUnit($ProcedureTraining);
  const categoriesList = (categories ?? []).map((category) => ({
    value: category.id + "",
    label: category.title,
  }));

  const [category, setCategory] = useState(SELECTS_ID);

  const { programs } = useStudyCenterProgramsQuery({
    categories:
      typeof category !== "undefined" && category !== SELECTS_ID
        ? `${category}`
        : undefined,
  });

  useEffect(() => {
    FetchAllCategoriesForTrainingPrograms({ isIncludeChanges: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.StudyCenter}>
      <div className={styles.head}>
        <div className={styles.tabs}>
          <div className={styles.tabs_active}>
            Формирование заявок на обучение
          </div>
          {permissions.hasPermission(
            ACTIONS.companyApplicationsForTraining_allowedToShow
          ) && (
            <NavLink to="/study-center/request-training">
              Заявки на обучение
            </NavLink>
          )}
        </div>
      </div>
      <div className={styles.StudyCenter__filters}>
        <GroupSwitch
          data={categoriesList}
          value={category !== SELECTS_ID ? `${category}` : ""}
          onChange={setCategory}
        />
        <a
          href="https://ucrbp.ru/?ysclid=lc07l6j1b802514322"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.StudyCenter__rbpLink}
        >
          <BodyNormal weight="bold">
            Учебный Центр ДПО переподготовки и повышения квалификации
          </BodyNormal>
          <ExternalLinkSVG />
        </a>
      </div>
      <div className={styles.StudyCenter__categories}>
        {programs?.map((program) => (
          <CategoryTable key={program.categoryId} category={program} />
        ))}
      </div>
    </div>
  );
};
